<script setup lang="ts">
const { t } = useI18n();
definePageMeta({
  layout: 'auth',
  middleware: 'guest',
  aliases: ['/login'],
});
useSeoMeta({
  title: t('pages.auth.login.title'),
  description: t('pages.auth.login.description'),
});
</script>

<template>
  <auth-login-form>
    <template #header>
      <nav-auth-panel>
        {{ t('pages.auth.login.title') }}
      </nav-auth-panel>
    </template>
  </auth-login-form>
</template>
